import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

export enum ORDERS_ROUTES_NAMES {
  Orders = "Orders",
  NewOrder = "New order",
  EditOrder = "Edit order",
  PreviewOrder = "Preview order",
  CorrectOrder = "Correct order",
  FormalOrder = "Formal order",
}

const OrdersRoutes: Array<CustomRouteConfig> = [
  {
    name: ORDERS_ROUTES_NAMES.Orders,
    path: "orders/:id?",
    component: () => import(/* webpackChunkName: "orders" */ "@/views/orders/OrdersIndexView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.OrdersRead] },
  },
  {
    name: ORDERS_ROUTES_NAMES.NewOrder,
    path: "orders/new",
    component: () => import(/* webpackChunkName: "orders" */ "@/views/orders/OrdersNewView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.OrdersCreate] },
  },
  {
    name: ORDERS_ROUTES_NAMES.EditOrder,
    path: "orders/edit/:id",
    component: () => import(/* webpackChunkName: "orders" */ "@/views/orders/OrdersEditView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.OrdersUpdate] },
  },
  {
    name: ORDERS_ROUTES_NAMES.PreviewOrder,
    path: "orders/preview/:id",
    component: () => import(/* webpackChunkName: "orders" */ "@/views/orders/OrdersPreviewView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.OrdersRead] },
  },
  {
    name: ORDERS_ROUTES_NAMES.CorrectOrder,
    path: "orders/correction/:id",
    component: () => import(/* webpackChunkName: "orders" */ "@/views/orders/OrdersCorrectView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.OrdersCreate] },
  },
  {
    name: ORDERS_ROUTES_NAMES.FormalOrder,
    path: "orders/formal-correction/:id",
    component: () => import(/* webpackChunkName: "orders" */ "@/views/orders/OrdersFormalView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.OrdersCreate] },
  },
];
export { OrdersRoutes };
export default OrdersRoutes;
